import { isValidPhoneNumber } from 'react-phone-number-input'
import { z } from 'zod'

export const extensionZodValidator = z
  .string()
  .max(6, 'Extensions are limited to 6 numbers')
  .optional()
  .refine((v) => {
    if (!v) return true
    return /^\d+$/.test(v)
  }, 'Extension must be a number')
export const phoneNumberZodValidor = z
  .string()
  .optional()
  .refine(
    (v) => {
      if (!v) return true
      return isValidPhoneNumber(v)
    },
    {
      message: 'Enter phone number as: +1 ### ### ####',
    }
  )

// Required-name + required-email atoms used by the recommendations card's
// inline create_contact form. Kept additive here so future callers can
// share them; ContactModal currently inlines its own equivalents and is
// intentionally untouched.
export const requiredFirstNameValidator = z
  .string()
  .trim()
  .min(1, 'First name is required')
export const requiredLastNameValidator = z
  .string()
  .trim()
  .min(1, 'Last name is required')
export const requiredEmailValidator = z
  .string()
  .trim()
  .min(1, 'Email is required')
  .email('Enter a valid email address')

export const ifExtensionThenPhoneNumberZodValidator = z
